
























































































































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {CommonApi} from '@/common/api/common';
import {DeepLoop} from '@/common/deepLoop/deepLoop';
import {Util, getPageAPIs} from '@/common/util';
import gallery from '@/components/gallery.vue';
import '@wangeditor/editor/dist/css/style.css';
import {DomEditor} from '@wangeditor/editor';
import {Editor, Toolbar} from '@wangeditor/editor-for-vue';
import ZlSelect from '@/components/third-custom-components/select';
import ZlOption from '@/components/third-custom-components/option';
import ShopPopupNoticeAPI from '@/common/api/operationManage/shopPopupNotice';

import {
  projectWebSitType2Ch,
  getCommonList,
  shareConfirmOptions,
} from '@/common/config';

export const pageApiList = getPageAPIs(ShopPopupNoticeAPI);
const defaultSearchVenuePageOption = {
  page: 1,
  limit: 10,
  isRearchBottom: false,
};
type InsertFnType = (url: string, alt: string, href: string) => void;

const defaultForm = {
  time: [],
};

// 状态:0下架,1上架
const dynamicStatus2ch: string[] = ['未发布', '已发布'];

const defaultForms: any = {
  title: '', // 标题
  content: '', // 富文本
  push_time: null, // 发布时间
  over_time: null, // 截止时间
  sort: '', // 排序
};

@Component({
  components: {
    gallery,
    WangToolbar: Toolbar,
    WangEditor: Editor,
    ZlSelect,
    ZlOption,
  }
})
export default class MerchantsAudit extends Vue {
  private ShopPopupNoticeAPI: any;
  private title: string = '';
  private is_show: boolean = false;
  private shieldVisible: boolean = false;
  private addShieldVisible:boolean = false
  private commonApi = new CommonApi();
  private form: any = {};
  private forms: any = {};

  private deepLoopUtil: any;

  constructor() {
    super();
    this.ShopPopupNoticeAPI = new ShopPopupNoticeAPI();

    this.deepLoopUtil = new DeepLoop();

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false),
    };

    this.wangEditorConfig = {
      placeholder: '请输入内容...',
      MENU_CONF: {
        uploadImage: {
          // 单个文件的最大体积限制，默认为 2M
          maxFileSize: 10 * 1024 * 1024, // 10M

          // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
          allowedFileTypes: ['image/*'],

          // 自定义上传
          customUpload: async (file: File, insertFn: InsertFnType) => {
            // TS 语法
            // async customUpload(file, insertFn) {                   // JS 语法
            // file 即选中的文件
            // 自己实现上传，并得到图片 url alt href
            // 最后插入图片
            this.commonApi.getOss(
                file,
                (res: any) => {
                  const {
                    // id,
                    url,
                    alt,
                    href,
                  } = res.data.data.item;

                  insertFn(url, alt, href);
                },
                () => {
                  this.$message.error('上传图片失败');
                }
            );
          },
        },
      },
    };
  }

  private daynamicDialogMode: string = 'new-add';

  private handleWakeDynamicDialog(mode: string): void {
    this.daynamicDialogMode = 'new-add';
    this.title = '新增';

    this.initDynamicDialogForms();

    this.is_show = true;
  }

  private async handleWakeEditDynamicDialog(row: any) {
    this.daynamicDialogMode = 'edit';
    this.title = '编辑';
    await this.initDynamicDialogForms(row);
    this.is_show = true;
  }

  private openShieldDialog(row: any): void {
    this.shieldVisible = true;
    this.shieldForm.shop_notice_id = row.id
    this.getShieldTable();
  }

  private openAddShieldDialog():void{
    this.addShieldVisible = true
    this.shopValue = {}
  }

  private onComfirmShield(row:any):void {
    this.ShopPopupNoticeAPI.confineAdd(
        {
          shop_id:this.shopValue.id,
          shop_notice_id:  this.shieldForm.shop_notice_id
        },
        () => {
          this.$message.success('添加成功');
          this.getShieldTable();
          this.addShieldVisible = false
        },
        () => {
        }
    );
  }

  /** 富文本 */
  private wangEditorIns: any = null;

  private wangEditorForm: any = {
    compete_info: '',
  };

  private wangEditorMode: string = 'default'; // or 'simple'

  private wangToolbarConfig: any = {
    // excludeKeys: ["insertLink", "group-video", "emotion", "insertImage", "insertTable", "fullScreen"]

    excludeKeys: [
      'group-video',
      'emotion',
      'insertImage',
      'insertTable',
      'fullScreen',
    ],
  };
  private wangEditorConfig: any = {};

  private get dOMWangEditor() {
    const refs: any = this.$refs || {};

    return refs.domWangEditor || {};
  }

  private onWangEditorCreated(editor: any) {
    this.wangEditorIns = Object.seal(editor);

    console.log(this.wangEditorIns, 'this.wangEditorIns');

    function getToolbarConfig(editor: any) {
      const toolbar: any = DomEditor.getToolbar(editor);

      console.log(toolbar, 'toolbar');

      const curToolbarConfig = toolbar.getConfig();

      console.log(curToolbarConfig.toolbarKeys, 'curToolbarConfig.toolbarKeys');
    }

    setTimeout(() => {
      getToolbarConfig(this.wangEditorIns);
    }, 1000);
  }

  /** 富文本 */

  private async initDynamicDialogForms(dynamicItem: any = null) {
    const mode = this.daynamicDialogMode;

    const forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    if (mode == 'edit') {
      const {
        id,
        title,
        content,
        sort,
        push_time,
        over_time,
      } = dynamicItem || {};


      Object.assign(forms, {
        id,
        title: title || '',
        content: content || '',
        push_time: push_time || null,
        over_time: over_time || null,
        sort,
      });

    }
    console.log(forms, 'forms');

    this.forms = forms;
  }


  private delMolisDynamic(row: any) {
    this.$confirm(`确定删除该通知?`, '', {
      ...shareConfirmOptions,
    }).then(() => {
      this.ShopPopupNoticeAPI.delete(
          {
            id: row.id,
          },
          () => {
            this.is_show = false;
            Util.showToast('删除成功');
            this.search();
          }
      );
    });
  }

  private onPublish(row:any):void{
    this.ShopPopupNoticeAPI.push(
        {
          id: row.id,
        },
        () => {
          Util.showToast('发布成功');
          this.search();
        }
    );
  }

  private handleDeleteBrilliantShowComment(row: any) {
    this.$confirm('确定删除该店铺吗?', '', {
      ...shareConfirmOptions,
    }).then(() => {
      this.ShopPopupNoticeAPI.confineDel(
          {
            id: row.id
          },
          () => {
            this.$message.success('删除成功');
            this.getShieldTable();
          },
          () => {
          }
      );
    });
  }

  private getMolisDynamicFormsParams() {
    const forms: any = this.forms;

    const mode = this.daynamicDialogMode;

    const {
      id,
      title,
      content,
      sort,
      push_time,
      over_time,
    } = forms || {};

    const params: any = {};

    if (mode == 'edit') {
      Object.assign(params, {
        id,
      });
    }

    if (!title) {
      this.$message.error('标题不可为空');
      return false;
    }

    if (!content) {
      this.$message.error('内容不可为空');
      return false;
    }


    if (!push_time) {
      this.$message.error('发布日期不可为空');
      return false;
    }

    if (!over_time) {
      this.$message.error('截止日期不可为空');
      return false;
    }

    Object.assign(params, {
      title,
      content,
      push_time,
      over_time,
      sort,
    });

    return params;
  }

  private submit(): void {
    const mode = this.daynamicDialogMode;

    const params = this.getMolisDynamicFormsParams();

    if (typeof params !== 'object') {
      return;
    }

    switch (mode) {
      case 'new-add':
        this.ShopPopupNoticeAPI.add(params, () => {
          this.is_show = false;
          Util.showToast('新增成功');
          this.search();
        });
        break;
      case 'edit':
        this.ShopPopupNoticeAPI.edit(params, () => {
          this.is_show = false;
          Util.showToast('修改成功');
          this.search();
        });
        break;
    }
  }

  private tableData: any[] = [];
  private shieldTableData: any[] = [];
  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };
  private shieldTablePage = {
    count: 0,
    page: 1,
    prepage: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
    totalPage: 0,
  };

  private shieldForm = {
    shop_notice_id : '',
    shop_name:''
  }

  private activated(): void {
    this.search();
  }

  private getTable(): void {
    const form = this.form || {};
    const {time} = form;
    let start_date;
    let end_date;
    if (time && time.length === 2) {
      [start_date, end_date] = time;
    }
    console.log(start_date, end_date);
    this.ShopPopupNoticeAPI.list(
        {
          page: this.tablePage.pageNo,
          limit: this.tablePage.pageSize,
          start_date,
          end_date,
        },
        (res: any) => {
          this.tableData = res.data.list;
          this.tablePage.totalCount = res.data.count;
        }
    );
  }

  private getShieldTable(): void {
    this.ShopPopupNoticeAPI.confine(
        {
          page: this.shieldTablePage.page,
          limit: this.shieldTablePage.prepage,
          ...this.shieldForm,
        },
        (res: any) => {
          this.shieldTableData = res.data.list;
          this.shieldTablePage.page = res.data.page;
          this.shieldTablePage.prepage = res.data.prepage;
          this.shieldTablePage.count = res.data.count;
        },
        () => {
        }
    );
  }

  private restForm(): void {
    this.form = new Util().clearObject(this.form);
    this.getTable();
  }

  private restFormShield(): void {
    this.shieldForm.shop_name = ''
    this.getShieldTable();
  }



  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getTable();
  }

  private searchShield(): void {
    this.shieldTablePage.page = 1;
    this.shieldTableData = [];
    this.tablePage.count = 0;
    this.getShieldTable();
  }

  

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;
    this.getTable();
  }


  private handlePageChangeComment(val: any) {
    this.shieldTablePage.page = val.currentPage;
    this.shieldTablePage.prepage = val.pageSize;
    this.getShieldTable();
  }

  private shopValue: any = {};
  private venueList: any[] = [];
  private addVenueListLoading: boolean = false;
  private searchVenueLoading: boolean = false;
  private remoteGetVenueQueryString: string = '';
  private searchVenuePageOption: any = {};
  private remoteSearchVenueTimer: any = null;

  private remoteGetVenueMethod(query: string) {
    query = query.trim ? query.trim() : '';
    if (query !== '') {
      this.remoteGetVenueQueryString = query;
      this.remoteSearchVenueTimer = setTimeout(() => {
        this.searchVenueLoading = true;
        this.getMoreVenueList();
      }, 300);
    } else {
      this.remoteGetVenueQueryString = '';
      this.venueList = [];
    }
  }

  private remoteAddVenueMethod() {
    if (this.addVenueListLoading) {
      return;
    }
    const searchVenuePageOption = this.searchVenuePageOption;

    const {isRearchBottom} = searchVenuePageOption;

    if (isRearchBottom) {
      return;
    }

    this.searchVenuePageOption.page++;

    this.addVenueListLoading = true;

    this.getMoreVenueList(false);
  }

  // 第一次搜索 无关键字
  private handleFirstGetVenueList() {
    this.searchVenueLoading = true;

    this.getMoreVenueList(true);
  }

  // 清空搜索
  private handleClearGetVenueList() {
    this.remoteGetVenueQueryString = '';

    this.searchVenueLoading = true;

    this.getMoreVenueList(true);
  }

  private initRemoteGetVenuePageOption() {
    this.searchVenuePageOption = {
      ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
    };
  }

  private getSearchVenueParams() {
    const searchVenuePageOption = this.searchVenuePageOption;

    const remoteGetVenueQueryString = this.remoteGetVenueQueryString;

    const {page, limit} = searchVenuePageOption;

    const params: any = {
      page,
      limit,
    };

    if (remoteGetVenueQueryString && remoteGetVenueQueryString.trim()) {
      params.name = remoteGetVenueQueryString.trim();
    }

    return params;
  }

  private getMoreVenueList(refresh: boolean = true) {
    return new Promise((resolve: Function, reject: Function) => {
      if (refresh) {
        this.initRemoteGetVenuePageOption();
      }

      const params = this.getSearchVenueParams();

      this.ShopPopupNoticeAPI.searchVenueList(
          params,
          (res: any) => {
            console.log(res, 'res');

            const venueList: any[] = res.data || [];

            this.venueList = refresh
                ? venueList
                : this.venueList.concat(venueList);

            if (Array.isArray(res.data) && res.data.length == 0) {
              this.searchVenuePageOption.isRearchBottom = true;
            }
            this.searchVenueLoading = false;

            this.addVenueListLoading = false;

            resolve();
          },
          () => {
            this.searchVenueLoading = false;

            this.addVenueListLoading = false;

            reject();
          }
      );
    });
  }
}
